import { isBrowser } from './trick';

// 子应用的路径map
export const subAppPaths = {
  inscription: '/web3/inscription',
  'crypto-ark': '/web3/crypto-ark',
  airdrop: '/web3/airdrop',
  'nft-pro': '/web3/nft-pro',
  home: '/web3/home',
  dex: '/web3/dex',
};

/** 荷兰站限制路由，连接云钱包需要弹窗拦截 */
export const NL_LAW_ROUTES = ['/web3/inscription', '/web3/nft-pro', '/web3/swap', '/web3/buy-crypto', '/web3/dex'];

// 这些语言下要需要隐藏的菜单
export const localeHiddenMenus = {
  'zh-HK': ['apex'],
  'en-HK': ['apex'],
  // 荷兰站放开：airdrop
  'en-NL': ['apex', 'ido', 'nft'],
  'nl-NL': ['apex', 'ido', 'nft'],
};

// 检查某语言是否支持某业务
export const checkSupport = (locale: string, business: string): boolean => {
  const hiddenList = localeHiddenMenus[locale] || [];
  return !hiddenList.includes(business);
};

// rtl 的语言
export const rtlLocales: string[] = ['ar-SA'];

// 语言包项目
export const i18nProjectName = 'web3-common';

export const CURRENT_DOMAIN = isBrowser ? window.location.hostname.split('.').slice(-2).join('.') : 'bybit.com';

export const walletGuideStorageKey = 'web3_wallet_guide';

// 用来存储三方钱包的信息
export const walletHubCenterStorageKey = 'web3-wallet-center';

// 云钱包的 evm chain id临时存储
export const cloudWalletChainId = 'cloud-wallet-chainId';

export const showBalanceStorageKey = 'web3_show_assets';

// 缓存的chain 信息
export const chainNamesStorageKey = 'web3_chain_names';

// 缓存search 信息
export const searchStorageKey = 'web3-search-his';

export const walletReferralQueryKey = 'wallet_referral';
export const walletReferralCookieName = 'web3_referral';

// 钱包的id map
export const walletIdMap = {
  coinbase: 'com.coinbase.wallet',
  metamask: 'io.metamask',
  okx: 'com.okex.wallet',
  phantom: 'app.phantom',
  bybit: 'com.bybit',
  walletConnect: 'walletConnect',
  bybitWalletConnect: 'bybitWalletConnect',
};

export const minBybitExtVersion = '4.1.2';

export const SOL_CHAIN_ID = 999999997;
export const BTC_CHAIN_ID = 999999999;
export const STX_CHAIN_ID = 999999996;
export const TON_CHAIN_ID = 999999991;
export const SUI_CHAIN_ID = 999999998;
export const TRON_CHAIN_ID = 728126428;
